import React from 'react'
import PropTypes from 'prop-types'
import Button from '../elements/Button'
import FormHOC from './FormHOC'
import TermsOfUseCheckbox from '../components/TermsOfUseCheckbox'
import TermsAndConditionsCheckbox from '../components/TermsAndConditionsCheckbox'
import {
    mapCisToType,
    mapKeyFactsToType,
    mapServiceTypeToTitle,
    mapTermsToType,
    SERVICE_FIBRE,
    SERVICE_NBN
} from '../constants'
import ComparePlans from '../components/ComparePlans/ComparePlans'
import globals from '../globals'
import BestPlanAvailable from '../components/BestPlanAvailable'
import ReactModal from '../modules/ReactModal'
import { TweenMax } from 'gsap'

const options = {
    postUrl: '/api/postChangePlanBroadband',
    success: 'Success! Your plan has been updated.'
}

const state = {
    serviceId: '',
    planId: null,
    termsOfUse: false,
    termsAndConditions: false,
    homeSecureSelected: false,
    referrerCode: '',
    flipRequested: false
}

class BroadbandPlanForm extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            currentPlan: {},
            showFlipPopup: false,
            currentPlanSpeed: 0
        }
    }

    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })

        this.setCurrentPlan()
    }

    componentDidUpdate (prevProps, prevState, snapshot) {
        if (prevProps.plans !== this.props.plans) {
            this.setCurrentPlan()
        }
    }

    handleChangePlan (id) {
        this.props.setDynamicValues({
            planId: id
        }, this.setCurrentPlan.bind(this))
    }

    handleToggleHomeSecure (event) {
	    event.preventDefault()
	    this.props.setDynamicValues({
            homeSecureSelected: !this.props.values.homeSecureSelected
        })
    }

    handleSubmit () {
        if (!this.props.values.flipRequested && this.isFlipReadyAnd100(this.state.currentPlan)) {
            this.setState({ showFlipPopup: true, currentPlanSpeed: 100 })
        } else if (!this.props.values.flipRequested && this.isFlipReadyAndOver100(this.state.currentPlan)) {
            this.setState({ showFlipPopup: true, currentPlanSpeed: 250 })
        } else {
            this.props.handleSubmit()
        }
    }

    handleSubmitPopup (flipRequested) {
	    this.props.setDynamicValues({ flipRequested: flipRequested }, () => {
	        this.props.handleSubmit()
        })
    }

    setCurrentPlan () {
        if (this.props.values.planId) {
            this.props.plans.map(plan => {
                if (this.props.values.planId === plan.id) {
                    this.setState({ currentPlan: plan })
                }
            })
        } else {
            this.setDefaultPlan()
        }
    }

    setDefaultPlan () {
	    // Don't set a default plan for flip users since we need to trigger a popup
	    if (!this.props.serviceDetails.flipReady) {
            if (this.props.plans.length > 0 && this.props.plans[1]) {
                this.props.setDynamicValues({
                    planId: this.props.plans[1].id
                }, () => this.setState({ currentPlan: this.props.plans[1] }))
            }
        }
    }

    getSelectedPlan () {
        let plan = this.state.currentPlan

        if (!plan) {
            plan = this.getDefaultAvailablePlan()
        }

        return plan || {}
    }

    getDefaultAvailablePlan () {
        return this.props.plans[1]
    }

    isFlipReadyAnd100 (plan) {
        const speed = parseInt(plan.planSpeed.replace('nbn', ''))

        return plan.flipOnly && speed === 100
    }

    isFlipReadyAndOver100 (plan) {
        const speed = parseInt(plan.planSpeed.replace('nbn', ''))

        return plan.flipOnly && speed > 100
    }

    mapExistingPlanFields () {
	    return {
            title: this.props.serviceDetails.planTitle,
            data: this.props.serviceDetails.allowance,
            speed: this.props.serviceDetails.planSpeed,
            eveningSpeed: this.props.serviceDetails.eveningSpeed ? this.props.serviceDetails.eveningSpeed : '',
            price: this.props.serviceDetails.monthlyFee,
            features: []
        }
    }

    mapApiPlanFields () {
	    const plans = []

        this.props.plans.forEach(plan => {
            let totalMinCost = plan.price
            if (plan.special && plan.special.planPrice) {
                totalMinCost = plan.special.planPrice
            }

            let additionalText = ''
            if (this.props.serviceDetails.flipReady) {
                if (this.isFlipReadyAnd100(plan)) {
                    additionalText = <span className='bold'>{this.props.serviceDetails.ftfDiscountPromoApplies ? 'Flip to Fibre™ + Upgrade and save $60/year!' : 'Get FREE Flip to Fibre™ upgrade'}</span>
                } else if (this.isFlipReadyAndOver100(plan)) {
                    additionalText = <span className='bold'>{this.props.serviceDetails.ftfDiscountPromoApplies ? 'Flip to Fibre™ + Upgrade and save $60/year!' : 'Only with Flip to Fibre™ upgrade'}</span>
                }
            }

            plans.push({
                id: plan.id,
                title: plan.planHeading ? plan.planHeading : plan.planTitle,
                data: plan.allowance,
                speed: `${plan.planFullSpeed} Mbps`,
                eveningSpeed: plan.eveningSpeed,
                price: plan.price,
                priceNotes: plan.priceNotes,
                features: [],
                special: plan.special ? plan.special : null,
                totalMinCost: totalMinCost,
                flipToFibrePriceDiscount: plan.priceWithFTFDiscount ? plan.priceWithFTFDiscount : '',
                additionalText1: additionalText
            })
        })

	    return plans
    }

    handleCloseModal (deselectPlan = false) {
	    this.setState({ showFlipPopup: false })
	    if (deselectPlan) {
	        this.setState({ currentPlan: {} })
        }
    }

    scrollToTerms (event) {
	    event.preventDefault()
	    this.handleCloseModal()
        TweenMax.to(window, 0.5, { scrollTo: { y: document.getElementById('terms'), offsetY: 60 } })
    }

    render () {
	    const providerTitle = () => {
	        if (this.props.provider === SERVICE_NBN) {
	            return mapServiceTypeToTitle[SERVICE_NBN]
            }

	        return this.props.provider
        }

	    const cisLink = () => {
	        if (this.props.plans.length > 0) {
	            return this.props.plans[0].cisLink
            }

	        return mapCisToType[this.props.type]
        }

	    const Flip100Popup = () => {
	        return (
                <div className='row text-center pt-3 py-lg-4'>
        <div className='col-12 col-lg-8 offset-lg-2'>
                        <h2 className='m-0 mb-2 color-indigo'>We highly recommend you Flip to Fibre™ for FREE with your 100Mbps service</h2>
                        <p>To get the most out of upgrading your plan to a 100Mbps service we highly recommend taking advantage of our FREE Fibre-to-the-home connection upgrade as well.</p>
                        <p>By confirming Flip to Fibre™ here, Exetel will change your plan immediately and commence upgrading your connection to Fibre-to-the-home for <span className='bold'>FREE from {this.props.serviceDetails.flipDate}</span>. See <a href='#' onClick={this.scrollToTerms.bind(this)}>Things you need to know</a> for more details.</p>
                        <div className='text-center my-4'>
                <Button action={() => this.handleSubmitPopup(true)} className='mr-3 mb-3 mb-lg-0'>Flip to Fibre™</Button>
                <Button action={() => this.handleSubmitPopup(false)} className='mr-3' color='grey'>Change plan without</Button>
            </div>
                        <p className='font-small'>FTTN or FTTC technology may not be able to fully deliver your selected new plan speed. However, if you do opt to stay on your current connection we’ll run a speed check after your plan change and give you options if there is an issue.</p>
                    </div>
    </div>
            )
        }

        const FlipOver100Popup = () => {
            return (
                <div className='row text-center pt-3 py-lg-4'>
                    <div className='col-12 col-lg-8 offset-lg-2'>
                        <h2 className='m-0 mb-2 color-indigo'>To change plan to speeds of 250Mbps or higher you must Flip to Fibre™. <br />Upgrading is FREE.</h2>
                        <p>By confirming Flip to Fibre™ here, Exetel will change your plan immediately to Power Home 100/40 Mbps and commence upgrading your connection to Fibre-to-the-home for <span className='bold'>FREE from {this.props.serviceDetails.flipDate}</span>.</p>
                        <p>As soon as your FREE Fibre-to-the-home upgrade connection is active your new high-speed (250Mbps or over) Exetel nbn™ plan will activate automatically. See <a href='#' onClick={this.scrollToTerms.bind(this)}>Things you need to know</a> for more details.</p>
                        <div className='text-center my-4'>
                            <Button action={() => this.handleSubmitPopup(true)} className='mr-3 mb-3 mb-lg-0'>Flip to Fibre™</Button>
                            <Button action={() => this.handleCloseModal(true)} className='mr-3' color='grey'>No thanks</Button>
                        </div>
                        <p className='font-small'>FTTN or FTTC technology may not be able to fully deliver your selected new plan speed. However, if you do opt to stay on your current connection we’ll run a speed check after your plan change and give you options if there is an issue.</p>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <div className='row'>
                    <div className='col-12 col-md-8 offset-md-2 text-center'>
                        <p dangerouslySetInnerHTML={{ __html: `Switching your Exetel ${mapServiceTypeToTitle[this.props.type]} plan is easy and free!.` }} />
                        <p dangerouslySetInnerHTML={{ __html: `You can move to a higher or lower plan price without any extra fees. However, if you're in a fixed-term contract, you’ll keep the same contract end date and terms after changing plan, but you may be liable for an early termination charge.` }} />
                        <p dangerouslySetInnerHTML={{ __html: `If you’re currently enjoying promotional pricing and upgrade your plan to a higher speed tier, any remaining promotional pricing will adjust to match the new plan’s promotional pricing if available, prorated for the remainder of the months remaining in the discount period of the original Exetel plan only. However, you will lose all promotional pricing and may be charged a plan change fee or cancellation fee if you choose to downgrade your plan to a lower speed tier and revert to the standard list price of the new plan.` }} />
                        <p dangerouslySetInnerHTML={{ __html: `Switch to the Family nbn 100/20 plan (or higher) now and enjoy a FREE Fibre-to-the-Home upgrade.` }} />
                        <p dangerouslySetInnerHTML={{ __html: `Keep in mind, you can change plans only once a month. If you’re unsure about any discounts you’re currently getting, check your invoices or the terms and conditions for more details. You can also find more information about switching plans <a class='underline' href="#terms">here</a> and promotional offers in our terms and conditions <a class='underline' href="https://www.exetel.com.au/terms" target='_blank'>here</a>.` }} />
                        {this.props.serviceDetails.flipReady && this.props.serviceDetails.ftfDiscountPromoApplies ? <p dangerouslySetInnerHTML={{ __html: globals.noWidows('Get a $5 discount off your monthly internet bill for twelve months when you Flip to Fibre™ and upgrade from your current plan to any of our Family nbn 100/20Mbps, Power Home 100/40Mbps, or our Superfast 250/20Mbps plans. Enjoy faster speeds, monthly savings, and a FREE FTTP (Fibre to the Premises) connection upgrade.') }} /> : ''}
                    </div>
                </div>
                {this.props.plans.length > 0
                    ? <React.Fragment>
                        <div className={`row ${this.props.plans.length > 5 ? 'hide-current-plan' : ''}`}>
                            <div className='col-12 px-2 px-lg-4 pt-lg-4'>
                                <h2 className='text-center' dangerouslySetInnerHTML={{ __html: globals.noWidows(`Choose your new ${providerTitle()} plan below:`) }} />
                                <ComparePlans
                                    type={this.props.type}
                                    plans={this.mapApiPlanFields()}
                                    existingPlan={this.mapExistingPlanFields()}
                                    handleSelect={this.handleChangePlan.bind(this)}
                                    selectedPlanId={this.state.currentPlan.id}
                                    isFlipReady={this.props.serviceDetails.flipReady}
                                    f2fPromo={this.props.serviceDetails.ftfDiscountPromoApplies}
                                />
                                <div className='row mt-2'>
                                    <div className='col-12 text-center mb-3'>
                                        <small><a href={cisLink()} target='_blank'>Critical information summary</a> & <a href={mapKeyFactsToType[this.props.type]}>Key facts sheet</a></small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='row mb-4'>
                            <div className='col-12 col-md-6 offset-md-3 text-center'>
                                <span className='bold'>Note:</span><br />
                                Your current Home Phone Call Rates or any Unlimited Call Pack you may have attached to this service will remain unchanged
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2'>
                                <TermsOfUseCheckbox
                                    errors={this.props.errors}
                                    value={this.props.values.termsOfUse}
                                    handleClick={value => this.props.setDynamicValues({ termsOfUse: value })}
                                    cisUrl={this.getSelectedPlan().cisLink}
                                    termsUrl={mapTermsToType[this.props.type]}
                                />
                                <br />
                                <TermsAndConditionsCheckbox
                                    errors={this.props.errors}
                                    value={this.props.values.termsAndConditions}
                                    handleClick={value => this.props.setDynamicValues({ termsAndConditions: value })}
                                    type={this.props.type}
                                />
                                <br />
                                {this.props.children}
                            </div>
                        </div>

                        <div className='row my-4'>
                            <div className='col-12 col-md-4 offset-md-2 text-center text-md-left my-2'>
                                <Button title='Submit Change' action={this.handleSubmit.bind(this)} />
                            </div>
                            <div className='col-12 col-md-4 text-center text-md-right my-2'>
                                <input placeholder='Referrer Code' name='referrerCode' value={this.props.values.referrerCode} onChange={this.props.handleInputChange} />
                            </div>
                        </div>
                    </React.Fragment>
                    : <BestPlanAvailable />}

                <ReactModal showModal={this.state.showFlipPopup} handleCloseModal={this.handleCloseModal.bind(this)}>
                    {this.state.currentPlanSpeed === 100 ? <Flip100Popup /> : <FlipOver100Popup />}
                </ReactModal>
            </div>
        )
    }
}

BroadbandPlanForm.propTypes = {
    type: PropTypes.oneOf([SERVICE_NBN, SERVICE_FIBRE]).isRequired,
    serviceId: PropTypes.string,
    plans: PropTypes.array.isRequired,
    provider: PropTypes.string.isRequired,
    serviceDetails: PropTypes.object.isRequired,
    isNotSubscribedAndNotInFreeTrial: PropTypes.bool
}

export default FormHOC(BroadbandPlanForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/BroadbandPlanForm.js